export default __webpack_public_path__ + "static/media/courses.9cd84f98.jpeg";